import { useState, useEffect } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../../../../config/firebaseConfig";

/**
 * Custom hook to watch lots for current terminal and product
 */
export function useLots(terminal, produit) {
  const [lots, setLots] = useState([]);
  const [lotsLoading, setLotsLoading] = useState(true);

  useEffect(() => {
    console.log("🔍 GSousDouane: Starting lots watcher", { terminal, produit });
    setLotsLoading(true);

    // Determine collection based on product: su=essence, go=mazout
    const lotsCollection = produit === "essence" ? "lots_su" : "lots_go";
    const lotsRef = collection(db, "terminaux", terminal, lotsCollection);

    const unsubscribe = onSnapshot(
      lotsRef,
      (snapshot) => {
        console.log("📦 Lots snapshot received:", snapshot.size, "documents");
        const lotsData = [];
        snapshot.forEach((doc) => {
          const data = { id: doc.id, ...doc.data() };
          console.log("  Lot:", data.id, data);
          lotsData.push(data);
        });
        // Sort by date (newest first)
        lotsData.sort((a, b) => {
          const dateA = a.createdAt?.seconds || 0;
          const dateB = b.createdAt?.seconds || 0;
          return dateB - dateA;
        });
        console.log("✅ Sorted lots:", lotsData.length);
        setLots(lotsData);
        setLotsLoading(false);
      },
      (error) => {
        console.error("❌ Error watching lots:", error);
        setLotsLoading(false);
      },
    );

    return () => unsubscribe();
  }, [terminal, produit]);

  return { lots, lotsLoading };
}
